import React, { useEffect } from "react"
import { addAnalyticsForNewsletterSignupOverlay } from "@/components/NewsLetterSignUpOverlay/v1/analytics"
import Checkbox from "@/components/core/Checkbox/Checkbox"

const NewsLetterForm = ({
  setEmail,
  overlayError,
  onFormSubmit,
  ctaLabel,
  heritageCheckbox = {},
  setHeritageCheckbox,
}) => {
  useEffect(() => {
    addAnalyticsForNewsletterSignupOverlay()
  }, [])

  const checkboxChangeHandler = (e, label = "") => {
    const { target: { checked = false } = {} } = e
    const modifyHeritageCheckbox = { ...heritageCheckbox }
    modifyHeritageCheckbox[label] = checked
    setHeritageCheckbox(modifyHeritageCheckbox)
  }

  const heritageCheckboxKeys = Object.keys(heritageCheckbox) || []

  return (
    <form onSubmit={e => e.preventDefault()} className="ui form">
      <input
        onChange={e => setEmail(e.target.value)}
        id="newsletter-overlay-input"
        className="news-letter-sign-up__email-input"
        type="text"
        placeholder={"Email Address*"}
      />

      <p id="overlay-mail-error" className="overlay-mail-errormsg">
        {overlayError}
      </p>
      {heritageCheckboxKeys.map(item => {
        return (
          <div className="news-letter-sign-up__checkbox1" key={item}>
            <Checkbox
              value={item}
              checked={heritageCheckbox[item]}
              onChange={e => checkboxChangeHandler(e, item)}
            ></Checkbox>
          </div>
        )
      })}

      <input
        className="news-letter-sign-up__button"
        type="button"
        onClick={onFormSubmit}
        value={ctaLabel}
      ></input>
    </form>
  )
}

export default NewsLetterForm
